import gql from 'graphql-tag';

export const GET_DELIVERY_ACTUALS_NUMBER_LIST = gql`
    query(
        $start_day: String
        $end_day: String
        $delivery_id: String
        $golf_code: String
        $begin_row: Int
        $limit_rows: Int
        ){
            getDeliveryActualsNumberList(
                start_day: $start_day
                end_day: $end_day
                delivery_id: $delivery_id
                golf_code: $golf_code
                begin_row: $begin_row
                limit_rows: $limit_rows
            ){
            DeliveryActualsNumberList {
                delivery_id
                delivery_date
                template_code
                delivery_name
                executed_number
                executed_number_char
                delivery_result_ok
                delivery_result_ok_char
                valid_flag
            }
            count
        }
    }
`;

export const GET_DELIVERY_ACTUALS_DETAILS = gql`
    query(
        $delivery_id: Int
        $delivery_date: String
        ){
            getDeliveryActualsDetails(
                delivery_id: $delivery_id
                delivery_date: $delivery_date
            ){
            DeliveryActualsDetailsList {
                delivery_type
                template_code
                code_name
                delivery_id
                executed_number
                executed_number_char
                delivery_result_ok
                delivery_result_ok_char
            }
        }
    }
`;
